var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticStyle:{"position":"absolute","top":"0","left":"0","bottom":"0","right":"0","margin":"auto"},style:({ width: _vm.width, height: _vm.width })})}
var staticRenderFns = []

export { render, staticRenderFns }